import styled, { keyframes } from "styled-components";
import { Colors } from "../config/Constants";

export const SpinnerLoader = () => {
  return (
    <LoaderWrapper>
      <StyledLoader />
    </LoaderWrapper>
  );
};

const spinner = keyframes`
from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledLoader = styled.div`
  width: 25px;
  height: 25px;
  border: 10px solid ${Colors.white};
  border-top: 10px solid ${Colors.shark};
  border-radius: 50%;
  animation: ${spinner} 1.5s linear infinite;
`;
